import marketPlaces from '../constants/MarketPlaces';
import marketplacePropertiesService from '../services/MarketplacePropertiesService';
import storeManager from '../store/StoreManager';
import DefaultThemeService from './services/default/DefaultThemeServices';
import CeqService from './services/ceq/CeqServices';
import FjordService from './services/fjord/FjordServices';

let instance = null;

const themeServices = {
    getThemeInstance() {
        const { ui } = storeManager.getState();
        if (instance !== null) {
            return instance;
        }

        switch (ui.marketplaceTheme) {
        case marketPlaces.fjord:
        case marketPlaces.cambridge_innovation:
            instance = new FjordService();
            break;
        case marketPlaces.ceq:
            instance = new CeqService();
            break;
        default:
            instance = new DefaultThemeService();
            break;
        }

        return instance;
    },

    isThemeOld(themeName) {
        return String(themeName).endsWith('-old');
    },

    isCeq() {
        return marketplacePropertiesService.getUiTheme() === marketPlaces.ceq;
    },
};

export default themeServices;
